<template>
  <div class="weightTracker">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg">
          <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
            <h5 class="txt-dark waterTitle">Water Tracker</h5>
          </div>
        </div>
        <!-- /Title -->
        <div class="row mb-20">
            <div class="col-xs-12 col-lg-2">
                <Datepicker style="margin-left:8px;margin-right:8px;" inputClass="form-control" v-model="date"></Datepicker>
								<!-- <datetime style="margin-left:10px;" input-id="startDate" v-model="date">
									<template slot="button-cancel">
										<fa :icon="['far', 'times']"></fa>
										Cancel
									</template>
									<template slot="button-confirm">
										<fa :icon="['fas', 'check-circle']"></fa>
										Confirm
									</template>
								</datetime> -->
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <WaterTracker :date="date"></WaterTracker>
        </div>
    </div>    
      
    <!-- /Main Content -->
    <AppFooter></AppFooter>
  </div>
  </div>
</template>

<script>
	import API from '../../services/api.js';
	import AppHeader from '../../components/common/AppHeader.vue'
	import AppFooter from '../../components/common/AppFooter.vue'
	import WaterTracker from '../../components/common/WaterTracker.vue'
	import Datepicker from 'vuejs-datepicker';
	import {
		mapMutations,
	} from 'vuex';
	import { Datetime } from 'vue-datetime'
	// You need a specific loader for CSS files
	import 'vue-datetime/dist/vue-datetime.css'
	const api = new API();

	export default {
		components: {
			AppHeader,
			AppFooter,
			Datepicker,
			WaterTracker,
			Datetime,
		},
		data() {
			return {
				date: this.$store.getters.globalDate,
			}
		},
		mounted: function () {},
		watch: {
			'date': function () {
				this.$store.commit('updateGlobalDate', this.date);
			}
		},
	}
</script>

<style scoped>
@media only screen and (min-width: 1px) {
  .progress-table{
	  padding-top: 10px;
	  padding-bottom: 10px;
	  padding-left: 0px !important;
	  padding-right: 0px !important;
  }
}

@media only screen and (min-width: 768px) {
  .progress-table{
	  padding-top: 0px;
	  padding-bottom: 0px;
	  padding-left: 15px !important;
	  padding-right: 15px !important;
  }
}

table{
	border-collapse: collapse;
}

/* table th{
	font-weight: bold;
	text-align:center;
	padding: 15px;
	background: #ddd;
}

table td{
	text-align:center;
	padding: 15px;
	vertical-align: top;
	border: 1px solid #ccc;
} */

table td,
table th {
  text-align: center;
}
table td img {
  height: 100px;
}

.widget {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

.trash {
  color: rgba(204, 0, 0, 0.5);
}

.trash:hover {
  color: rgba(204, 0, 0, 1);
}
label {
  text-align: left;
}
.table-wrap {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.waterTitle{
	margin-left: 28px;
}
</style>


// WEBPACK FOOTER //
// src/views/WaterTracking/WaterTracking.vue